export const DEFAULT_VEHICLE_APPLICATION_OWNER: Record<
  string,
  Record<string, string>
> = {
  AUTOPAY: {
    emailAddress: 'save@thesavingsgroup.com',
    name: 'AUTOPAY',
    phoneNumber: '8442763272',
  },
  RateGenius: {
    emailAddress: 'save@rategenius.com',
    name: 'RateGenius',
    phoneNumber: '8667283436',
  },
  Tresl: {
    emailAddress: 'save@mytresl.com',
    name: 'Tresl',
    phoneNumber: '8446075252',
  },
};
